import {ChangeDetectorRef, Component, OnDestroy} from "@angular/core";
import {EntityModelStatus, provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {CategoryEntityModel} from "../category-entity.model";
import {PageParameterService} from "../../../framework/entity/page-parameter.service";
import {Subscription} from "rxjs";
import {CategoryData} from "../category.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-category-edit-page",
    templateUrl: "./category-edit-page.component.html",
    providers: [provideEntityModel(CategoryEntityModel), PageParameterService]
})
export class CategoryEditPageComponent extends AbstractEditPage implements OnDestroy {

    parentReadOnly: boolean;

    private subscriptions: Subscription = new Subscription();

    constructor(public model: CategoryEntityModel,
                private parameterService: PageParameterService,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
        this.subscriptions.add(this.model.$data.subscribe(() => {
            if (this.model.status === EntityModelStatus.INSERT) {
                this.parameterService.getParams().then((params) => {
                    if (params && params.categoryId) {
                        this.model.data.parent.categoryId = params.categoryId;
                        this.parentReadOnly = true;
                    }
                });
                this.model.data.rgbaColour = CategoryData.COLOR_DEFAULT;
            } else {
                this.parentReadOnly = true;
            }
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get applyMinimumAgePlaceholder(): string {
        return this.model.data.parent.categoryId ? "wbo.category.edit.field.applyMinimumAge.placeholder.withParent" : "wbo.category.edit.field.applyMinimumAge.placeholder.withoutParent";
    }

    get reorderableInAppPlaceholder(): string {
        return this.model.data.parent.categoryId ? "wbo.category.edit.field.reorderableInApp.placeholder.withParent" : "wbo.category.edit.field.reorderableInApp.placeholder.withoutParent";
    }

    categoryNameChanged(): void {
        this.model.data.reorderableInApp = (
            this.model.data.name.toLowerCase().indexOf("alcohol") >= 0 ||
            this.model.data.name.toLowerCase().indexOf("drink") >= 0 ||
            this.model.data.name.toLowerCase().indexOf("beverage") >= 0 ||
            this.model.data.name.toLowerCase().indexOf("beer") >= 0 ||
            this.model.data.name.toLowerCase().indexOf("spirit") >= 0 ||
            this.model.data.name.toLowerCase().indexOf("wine") >= 0 ||
            this.model.data.name.toLowerCase().indexOf("cocktail") >= 0 ||
            this.model.data.name.toLowerCase().indexOf("mocktail") >= 0 ||
            this.model.data.name.toLowerCase().indexOf("cider") >= 0) ? true : null;
    }
}
